import React from "react";
import YoutubeEmbed from "./YoutubeEmbed";

const Company = () => {
  return (
    <div className="w-full">
      <div className="flex flex-col justify-center items-center mb-10">
        <h1 className="text-4xl font-bold text-white m-5">
          Quem Somos
        </h1>
        <YoutubeEmbed embedId="DnUZ8NW-ok4" />
      </div>
      
      
    </div>
  )
}

export default Company